import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/shared/Loader";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader label="Verifying access" />;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  }
  return children;
}
